import type { EntityState } from './generated/enums/EntityState';
import type { ISerialize } from './ISerialize';

export abstract class BaseObj implements ISerialize {
    public abstract serialize(): string;
    public abstract get EntityState(): EntityState;
    public abstract Delete(): void;
}
